import React from 'react';
import parse from 'html-react-parser';
import staticHTML from '/public/default/static/header.static.html';

export function Header() {
  return parse(staticHTML);
}
